export default {
  //demo
  test:'/wmsp/wmsp/test',//接口测试
  insertBusiness:'/wmsp/wmsp/user/insertBusiness',//图片上传
  getUserMassage:'/wmsp/wmsp/user/getUserMassage',//获取客户信息
  insertUserMessage:'/wmsp/wmsp/user/insertUserMessage',//注册客户信息
  getFile:'/wmsp/wmsp/user/getFile',//获取页面展示的附件
  getBusiness:'/wmsp/wmsp/user/getBusiness',
  updateBusiness:'/wmsp/wmsp/user/updateBusiness',//修改人脸识别状态
  deleteBusiness:'/wmsp/wmsp/user/deleteBusiness',//删除改房间记录
  confirmsign:'/wmsp/wmsp/user/confirmsign',//确认签字
  updateBusinesscolumn3:'/wmsp/wmsp/user/updateBusinesscolumn3',//发起电子签名
  updateimgfile:'/wmsp/wmsp/user/updateimgfile',//推送合成的附件图片

  featuresList: '/wmsp/authority/features/list_by_menu_url', // 获取菜单功能接口
  login: '/wmsp/authority/user/login', // 登录
  logout: '/wmsp/authority/user/logout', // 登出

  stopById: '/wmsp/job/task/single_job_stop', // 单条、批量终止任务
  // 日志模块-操作日志
  operateLogQuery: '/wmsp/log/sys/list', // 操作日志查询
  // 日志模块-人员登录日志
  personLoginQuery: '/wmsp/log/user/list', // 人员登录日志查询
  // 日志模块-交易日志
  transactionLogQuery: '/wmsp/log/deal/list', // 交易日志查询
  // 日志模块-job运行日志
  jobRunLogQuery: '/wmsp/log/job/get', // job运行日志查询
  // 日志模块-报文日志
  messageLogQuery: '/wmsp/log/message/list', // 报文日志查询

  // 维护管理模块-参数设置
  parameterQuery: '/wmsp/maintenance/param/list', // 参数查询
  parameterAdd: '/wmsp/maintenance/param/save', // 参数新增
  parameterEdit: '/wmsp/maintenance/param/update', // 参数修改
  parameterDelete: '/wmsp/maintenance/param/delete', // 参数删除
  // 维护管理模块-屏保管理
  screenQuery: '/wmsp/maintenance/screen/list', // 屏保查询
  screenAdd: '/wmsp/maintenance/screen/save', // 屏保新增
  screenEdit: '/wmsp/maintenance/screen/update', // 屏保修改
  screenEditWithoutImage: '/wmsp/maintenance/screen/update_screen_info', // 屏保修改 没有图片
  screenToggleStatus: '/wmsp/maintenance/screen/update_status', // 屏保修改（目前是和修改屏保状态一个接口）
  screenDelete: '/wmsp/maintenance/screen/delete', // 屏保删除
  screenPreview: '/wmsp/maintenance/screen/preview', // 屏保预览
  // 维护管理模块-字典管理
  dictGet: '/wmsp/maintenance/dict/get', // 获取对应字典值
  dictTypeQuery: '/wmsp/maintenance/dict_type/list', // 字典类别查询
  dictTypeAdd: '/wmsp/maintenance/dict_type/save', // 字典类别新增
  dictTypeEdit: '/wmsp/maintenance/dict_type/update', // 字典类别修改
  dictTypeDelete: '/wmsp/maintenance/dict_type/delete', // 字典类型删除
  dictValueQuery: '/wmsp/maintenance/dict/list', // 字典详情查询
  dictValueAdd: '/wmsp/maintenance/dict/save', // 字典值新增
  dictValueEdit: '/wmsp/maintenance/dict/update', // 字典值修改
  dictValueDelete: '/wmsp/maintenance/dict/delete', // 字典值删除

  // 统一认证模块-机构管理
  getHeadOrg: '/wmsp/authority/organization/get_head_organization_code', // 获取顶层机构
  listUserState: '/wmsp/authority/user/get_state_dict', // 获取人员状态
  listSystemRoleMenuTree: '/wmsp/authority/menu/list_system_role_menu_tree',
  subOrganizationList: '/wmsp/authority/organization/list_sub_organizations_tree', // 机构管理模块-获取下级机构树
  organizationGet: '/wmsp/authority/organization/get', // 机构管理模块-查询机构信息数据
  organizationDownload: '/wmsp/authority/organization/export', // 机构管理模块-导出机构接口
  organizationCheck: '/wmsp/authority/organization/check', // 机构信息数据校验
  subOrganizationsSearch: '/wmsp/authority/organization/list_sub_organizations', // 模糊查询机构
  // 统一认证模块-人员管理
  userListQuery: '/wmsp/authority/user/list', // 人员列表查询
  downloadUserList: '/wmsp/authority/user/export', // 导出列表
  passwordReset: '/wmsp/authority/user/reset', // 重置密码
  userExistCheck: '/wmsp/authority/user/check', // 查重校验
  userAdd: '/wmsp/authority/user/save', // 新增人员
  userUpdate: '/wmsp/authority/user/update', // 修改人员
  userMenuFunc: '/wmsp/authority/role/selectRoleMenuFuncTree',
  // 统一认证模块-角色管理
  roleAssign: '/wmsp/authority/role/assign', // 角色功能、菜单分配
  roleListByLevel: '/wmsp/authority/role/list_by_level', // 获取角色下拉
  saveRoleMenu: '/wmsp/authority/menu/save_role_menu', // 角色管理-角色菜单分配：保存数据接口
  roleListQuery: '/wmsp/authority/role/list', // 角色列表查询
  roleAdd: '/wmsp/authority/role/save', // 角色新增
  roleEdit: '/wmsp/authority/role/update', // 角色修改
  roleDelete: '/wmsp/authority/role/delete', // 角色删除
  roleDisable: '/wmsp/authority/role/disable', // 角色禁用
  // 统一认证模块-终端维护
  terminalListQuery: '/wmsp/authority/terminal/list', // 终端列表查询
  terminalAdd: '/wmsp/authority/terminal/save', // 终端新增
  terminalEdit: '/wmsp/authority/terminal/update', // 终端修改
  terminalDelete: '/wmsp/authority/terminal/delete', // 终端删除
  // 统一认证模块-功能管理
  functionSave: '/wmsp/authority/features/save', // 功能管理模块-新增功能数据接口
  functionList: '/wmsp/authority/features/list_features_tree', // 功能管理模块-角色功能分配数据接口
  functionSaveByRole: '/wmsp/authority/features/save_role_features', // 功能管理模块-角色菜单分配数据接口
  functionUpdate: '/wmsp/authority/features/update', // 功能管理模块-修改功能数据接口
  functionDelete: '/wmsp/authority/features/delete', // 功能管理模块-删除功能数据接口
  functionDataList: '/wmsp/authority/features/list', // 功能管理模块-查询功能列表数据接口
  functionListMenu: '/wmsp/authority/features/list_role_menu_features', // 功能管理模块-默认选中状态下的菜单功能数据接口
  // 统一认证模块-菜单管理
  menuUpdate: '/wmsp/authority/menu/update', // 菜单管理模块-修改菜单接口
  menuDelete: '/wmsp/authority/menu/delete', // 菜单管理模块-删除菜单接口
  menuSave: '/wmsp/authority/menu/save', // 菜单管理模块-新增菜单信息
  guideMenuList: '/wmsp/authority/menu/list_guide_menu', // 菜单管理模块-导航菜单
  menuList: '/wmsp/authority/menu/list', // 菜单管理模块-获取上级菜单下拉数据
  menuListByRole: '/wmsp/authority/menu/list_by_role', // 菜单管理模块-角色菜单分配数据接口//字典管理-获取归属菜单数据
  menuByRoleId: '/wmsp/authority/menu/list_role_menu_by_role_id', // 菜单管理模块-默认选中状态下的菜单数据接口
  menuGetById: '/wmsp/authority/menu/get', // 菜单管理模块-获取菜单详细描述

  // 现场服务模块-现场服务记录
  onsiteServiceQuery: '/wmsp/scene/field_service/list', // 现场服务记录查询
  serviceDetailListQuery: '/wmsp/scene/transaction_detail/list', // 服务明细列表
  serviceVoucherInfo: '/wmsp/scene/print_vouchers/get', // 打印凭证
  endService: '/wmsp/scene/field_service/update_service_state', // 结束服务
  videoSupplement: '/wmsp/scene/video/update', // 视频补录、结束补录
  videoBrowse: '/wmsp/scene/video/get', // 视频调阅
  // 双录参数设置
  recordParamListQuery: '/wmsp/scene/double_recording/list', // 双录参数列表
  disableService: '/wmsp/scene/double_recording/update_status', // 双录列表启禁用操作
  deleteService: '/wmsp/scene/double_recording/delete', // 双录列表删除操作
  recordParamAdd: '/wmsp/scene/double_recording/save', // 双录参数新增
  recordParamUpdate: '/wmsp/scene/double_recording/update', // 双录参数修改
  getDoubleParm: '/wmsp/scene/double_recording/get_double_recording_param', // 将双录参数写入外屏客户端
  // 现场服务模块-音频上传参数
  audioParamListQuery: '/wmsp/scene/audio/list', // 音频上传参数列表
  audioParamUpdate: '/wmsp/scene/audio/update', // 音频上传参数修改

  // 定时任务模块
  jobStartList: '/wmsp/job/task/single_job_start',
  jobHandStart: '/wmsp/job/task/hand_job_start', // 手动执行任务
  jobUpdate: '/wmsp/job/task/update', // 定时任务模块-修改
  jobDelete: '/wmsp/job/task/delete', // 定时任务模块-删除
  jobSave: '/wmsp/job/task/save', // 定时任务模块-新增
  jobFind: '/wmsp/job/task/get', // 定时任务模块-查询
  jobStopAll: '/wmsp/job/task/stop_all_job', // 定时任务模块-全部停止
  jobStartAll: '/wmsp/job/task/start_all_job', // 定时任务模块-全部启动
  jobStop: '/wmsp/job/task/stop_single_job', // 定时任务模块-单个停止
  jobStart: '/wmsp/job/task/start_single_job', // 定时任务模块-单个启动
  jobList: '/wmsp/job/task/list', // 定时任务模块-集合查询

  // 报表模块
  reportDownload: '/wmsp/report/form/download', // 报表模块-下载报表
  reportPost: '/wmsp/report/form/save', // 报表模块-创建报表
  reportList: '/wmsp/report/form/list', // 报表模块-查询报表条件队列

  systemList: '/wmsp/authority/system/list_all', // 系统管理
  systemRoleInfo: '/wmsp/authority/user/get_user_role_info', // 获取用户信息
  systemOrganization: '/wmsp/authority/login/get_user_organization', // 用户机构
  systemTerminal: '/wmsp/authority/terminal/get_by_id', // 终端注册

  // 客户管理-线索客户
  getPresentManagers: '/wmsp/authority/user/get_user_by_orgn', // 获取当前机构下所有的理财经理
  leadListQuery: '/wmsp/customer/sale_lead/list', // 线索客户列表
  leadAdd: '/wmsp/customer/sale_lead/save', // 新增线索(管理员)
  leadNormalAdd: '/wmsp/customer/sale_lead/save_and_self_assign', // 新增线索
  leadEdit: '/wmsp/customer/sale_lead/update', // 修改线索
  leadDelete: '/wmsp/customer/sale_lead/delete', // 删除线索
  leadDetail: '/wmsp/customer/sale_lead/get', // 线索详情
  leadDistribute: '/wmsp/customer/sale_lead/assign_batch', // 分配线索
  leadOperateHistory: '/wmsp/customer/sale_lead/record/list', // 操作历史
  adressGet: '/wmsp/maintenance/province_dict/list_all', // 获取省市区地址
  // 客户管理-客户列表
  custListQuery: '/wmsp/customer/custinfo/list', // 客户列表
  getOrganLists: '/wmsp/authority/organization/list_sub_organizations', // 获取机构
  contactTelPlans: '/wmsp/customer/contact_plan/save_batch', // 批量制定联络计划
  contactTelPlan: '/wmsp/customer/contact_plan/save_with_customer', // 制定联络计划
  createLeadPlan: ' /wmsp/customer/contact_plan/save_with_sales_lead ', // 创建联络计划
  getRiskLevelList: '/wmsp/maintenance/dict/use', // 客户风险等级下拉框

  // 客户管理-电访计划
  callPlanListQuery: '/wmsp/customer/contact_plan/list', // 电访计划列表分页查询
  updateCallPlan: '/wmsp/customer/contact_plan/update', // 修改
  updateCallPlanBatch: '/wmsp/customer/contact_plan/update_batch ', // 批量更新
  cancelBatch: '/wmsp/customer/contact_plan/cancel_batch', // 批量取消
  // 字典管理-下拉框字典值
  selectDict: '/wmsp/maintenance/dict/use',

  // 产品管理-理财产品
  financialListQuery: '/wpsp/inner/financez/get-product-list', // 获取理财产品列表
  getManageInfo: '/wmsp/finance/finance_info/get', // 获取管理信息
  changeSaleStatus: '/wmsp/finance/finance_manageinfo/update_sell_status', // 修改上下架状态
  changeDesc: '/wmsp/finance/finance_manageinfo/update_description_info', // 修改描述信息
  changeTopStatus: '/wmsp/finance/finance_manageinfo/update_top_flag', // 修改置顶状态
  getSaleOrgns: '/wmsp/finance/finance_info/list_sale_organ', // 销售机构

  // 风险话术
  listRiskTip: '/wmsp/risktip/risk_tip/list', // 列表
  listRiskTipDownMenu: '/wmsp/risktip/risk_tip/list_risk_tip', // 产品配置中风险话术下拉框
  listRiskTipDict: '/wmsp/risktip/risk_tip/selectDictMap', // 风险话术字典值
  postRiskTip: '/wmsp/risktip/risk_tip/save_risk_tip', // 新增
  updateRiskTip: '/wmsp/risktip/risk_tip/update_risk_tip', // 修改
  deleteRiskTip: '/wmsp/risktip/risk_tip/delete_risk_tip', // 删除
  getRiskTip: '/wmsp/risktip/risk_tip/selectRiskTipDetail', // 回显
  // 产品配置管理
  dataList: '/wmsp/prd/configuration/list', // 列表
  addProductType: '/wmsp/prd/configuration/save', // 新增
  modifyProductType: '/wmsp/prd/configuration/update', // 修改
  delProductType: '/wmsp/prd/configuration/delete', // 删除
  constaintdate: '/wmsp/prd/configuration/get', // 数据回显

  // 大额存单接口
  listCDS: '/wmsp/deposit/product/list', // 列表
  updateCDSTop: '/wmsp/deposit/manage/update_top', // 置顶
  updateCDSDesc: '/wmsp/deposit/manage/update_description', // 描述
  updateCDSSale: '/wmsp/deposit/manage/update_sale', // 上下架
  getCDSDetail: '/wmsp/deposit/manage/select_manage', // 管理信息

  // 附件管理
  uploadAnnex: '/wmsp/file/save', // 上传文件
  updateAnnex: '/wmsp/prd/attachment/update', // 修改文件
  annexList: '/wmsp/prd/attachment/list', // 附件列表
  changeStatus: '/wmsp/prd/attachment/change_status', // 禁用启用
  previewAnnex: '/wmsp/prd/attachment/preview', // 附件预览
  deleteAnnex: '/wmsp/prd/attachment/delete', // 删除附件
  uploadAttachment: '/wmsp/prd/attachment/save_common', // 上传附件
  selectType: '/wmsp/maintenance/dict/use', // 产品类型字典值下拉框
  listSaleOrg: '/wmsp/deposit/product/sub_organ_tree', // 销售机构树

  // 题目管理
  listQuestion: 'wmsp/question/task/list', // 题目列表
  postQuestion: '/wmsp/question/task/saveQuestion', // 新增题目
  checkAvailableQuestion: '/wmsp/question/task/find_by_array', // 检测可用的题目
  updateQuestion: '/wmsp/question/task/updateQuestion', // 修改题目
  listAvailableQuestion: '/wmsp/question/task/list_question_status', // 查询题库未禁用的题目列表
  updateQuestionStatus: '/wmsp/question/task/update_by_status', // 修改题目状态
  getQuestion: '/wmsp/question/task/findQuestion', // 查看题目详情
  deleteQuestion: '/wmsp/question/task/delete', // 删除题目
  listQuestionChoice: '/wmsp/choice/task/findAll', // 查询题目选项
  checkQuestion: '/wmsp/question/task/find_questions_exist', // 检测题目是否正在使用中

  listQuestionnaire: '/wmsp/questionnaire/quesnaire_info/list', // 问卷列表查询
  deleteQuestionnaire: '/wmsp/questionnaire/quesnaire_info/delete',
  postQuestionnaire: '/wmsp/questionnaire/quesnaire_info/save', // 保存问卷
  listQuestionSelected: '/wmsp/questionnaire/quesnaire_info/select_all_info_about_quesnaire', // 选中的题目
  checkQuestionnaire: '/wmsp/questionnaire/quesnaire_info/check', // 判断问卷是否存在
  updateQuestionnaireStatus: '/wmsp/questionnaire/quesnaire_info/update_stauts',
  updateQuestionnaire: '/wmsp/questionnaire/quesnaire_info/update', // 修改问卷

  // 产品管理-个性化附件
  accessoriesListQuery: '/wmsp/prd/attachment/list_customerized', // 获取附件列表
  addAccessory: '/wmsp/prd/attachment/save_customerized', // 增加附件
  editAccessory: '/wmsp/prd/attachment/update', // 修改附件
  delteAccessory: '/wmsp/prd/attachment/delete', // 删除附件
  changeAccessStatus: '/wmsp/prd/attachment/change_status', // 增加附件禁用启用状态

  listLatestProduct: '/wmsp/homepage/latest/select_list', // 最新产品
  todayAmount: '/wmsp/homepage/task/get_amount', // 今日成交额
  todayPlan: '/wmsp/homepage/task/get_contact_plan', // 今日计划
  visitNumber: '/wmsp/homepage/task/get_visit ', // 客户访问量
  getTrend: '/wmsp/homepage/task/get_achievement', // 走势图数据
  listTask: '/wmsp/homepage/task/get_list', // 业绩列表
  listIndexProduct: '/wmsp/homepage/latest/list', // 首页最新产品获取
  getTradeAmount: '/wmsp/homepage/task/get_amount',

  // 财富规划
  wpspListCustSupple: '/wpsp/inner/cust_info/list_cust_supple', // 查询客户家庭成员信息
  wpspGetCustInfo: `/wpsp/inner/cust_info/get_cust_info?random=${new Date().getTime()}`, // 查询客户基本信息
  wpspSaveFamilySupple: '/wpsp/inner/cust_info/save_family_supple', // 新增家庭关系
  wpspDeleteFamilySupple: '/wpsp/inner/cust_info/delete_family_supple', // 删除家庭关系
  wpspUpdateCheckFamilySupple: '/wpsp/inner/cust_info/check_child_name_update', // 修改家庭关系时候验证
  wpspUpdateFamilySupple: '/wpsp/inner/cust_info/update_family_supple', // 修改家庭关系
  wpspCheckChildName: '/wpsp/inner/cust_info/check_child_name_save', // 验证子女姓名
  wpspUpdateCustsupple: '/wpsp/inner/cust_info/update_cust_supple', // 更名基本信息补充
  createCustmerView: '/wmsp/customer/cust_label/get_list_by_cust_id', // 金融特征

  /** 财富规划-财务信息 */
  /** 查询客户财务信息 */
  getFinance: '/wpsp/inner/cust_finance_info/get_finance',
  /** 财务分析 */
  financialAnalysis: '/wpsp/inner/cust_finance_info/get_finance_analyze',
  /** 判断用户是否风评  */
  windReview: '/wpsp/inner/cust_info/get_cust_risk_level',
  /** 编辑客户财务信息 */
  editFinance: '/wpsp/inner/cust_finance_info/update_finance',
  /** 编辑客户总资产 */
  editFinanceTotalReq: '/wpsp/inner/cust_finance_info/update_finance_current',
  /** 编辑客户总负债 */
  editDebtTotalReq: '/wpsp/inner/cust_finance_info/update_debt_current',
  /** 查询客户收入信息 */
  getIncome: '/wpsp/inner/cust_income_info/get_income',
  /** 编辑客户收入信息 */
  editIncome: '/wpsp/inner/cust_income_info/update_income',
  /** 查询客户收出信息 */
  getExpend: '/wpsp/inner/cust_expend_info/get_expend',
  /** 编辑客户收出信息 */
  editExpend: '/wpsp/inner/cust_expend_info/update_expend',
  /** 财富规划-配置管理 */
  // 参数====》查询
  getParamList: '/wpsp/inner/wpsp_deploy_param/list_param',
  // 参数====》新增
  addParamDetail: '/wpsp/inner/wpsp_deploy_param/save_param',
  // 参数====》修改
  editParamDetail: '/wpsp/inner/wpsp_deploy_param/update_param',
  // 模块====》查询（不分页）
  getModuleList: '/wpsp/inner/wpsp_deploy_module/list_module',
  // 模块====》查询（分页）
  getModuleListPage: '/wpsp/inner/wpsp_deploy_module/list_module_page',
  // 模块====》新增
  addModuleDetail: '/wpsp/inner/wpsp_deploy_module/insert_module',
  // 模块====》修改
  editModuleDetail: '/wpsp/inner/wpsp_deploy_module/update_module',
  // 提示====> 查询
  getTipList: '/wpsp/inner/wpsp_deploy_tips/list_tips',
  // 提示====> 新增
  addTipDetail: '/wpsp/inner/wpsp_deploy_tips/save_tips',
  // 提示====> 修改
  editTipDetail: '/wpsp/inner/wpsp_deploy_tips/update_tips',
  // 提示====> 启禁用
  editTipStatus: '/wpsp/inner/wpsp_deploy_tips/update_tips_status',
  // 字典类别====> 查询
  getDictTypeList: '/wpsp/inner/wpsp_deploy_dict/list_dict_type',
  // 字典类别====> 新增
  addDictTypeDetail: '/wpsp/inner/wpsp_deploy_dict/save_dict_type',
  // 字典类别====> 修改
  editDictTypeDetail: '/wpsp/inner/wpsp_deploy_dict/update_dict_type',
  // 字典项====> 查询
  getDictList: '/wpsp/inner/wpsp_deploy_dict/list_dict',
  // 新增字典项 字典项====> 新增
  addDictDetail: '/wpsp/inner/wpsp_deploy_dict/insert_dict',
  // 字典项====> 修改
  editDictDetail: '/wpsp/inner/wpsp_deploy_dict/update_dict',
  // 字典项====> 修改状态
  editDictStatus: '/wpsp/inner/wpsp_deploy_dict/update_dict_status',
  // 字典项====> 修改排序
  editDictSort: '/wpsp/inner/wpsp_deploy_dict/update_dict_sort',
  // 产品方案===> 查询测算结论
  getMeasurePreview: '/wpsp/inner/child_edu/get_measure_preview',
  // 产品方案===> 查询建议方案
  getPlans: '/wpsp/inner/child_edu/get_reserve_advice_scheme',
  // 产品方案===> 查询常选产品列表
  getRegularPrdList: '/wpsp/inner/wpsp_product_plan/list_regular_product',
  // 产品方案===> 查询已选产品列表
  getSelectedPrdList: '/wpsp/inner/wpsp_product_plan/list_selected_products',
  // 产品方案===> 删除已选产品
  delSelectedPrd: '/wpsp/inner/wpsp_product_plan/delete_selected_product',
  // 产品方案===> 新增已选产品
  addSelectedPrd: '/wpsp/inner/wpsp_product_plan/save_selected_products',
  // 产品方案===> 新增常选产品多选
  addRegularPrd: '/wpsp/inner/wpsp_product_plan/save_regular_products',
  // 产品方案===> 新增产品单选
  addRegularPrdAlone: '/wpsp/inner/wpsp_product_plan/save_selected_product',
  // 产品方案===> 查询理财产品
  getFinanceList: '/wpsp/inner/financez/get-product-list',
  // 产品方案===> 查询理财产品详情
  getFinanceDetail: '/wpsp/inner/wpsp_product_plan/select_product_info',
  // 产品方案===> 查询大额存单产品
  getDepositList: '/wpsp/inner/financez/get-product-list',
  // 产品方案===> 查询大额存单产品详情
  getDepositDetail: '/wpsp/inner/wpsp_product_plan/select_product_info',
  // 产品方案===> 保存购买金额
  savePurchaseAmounts: '/wpsp/inner/wpsp_product_plan/save_purchased_money',
  // 子女教育模块
  // 子女教育第一步
  // 查询教育储蓄金
  getSaveChildEduReserve: '/wpsp/inner/children_edu_collect/get_children_reserve',
  // 查询教育费用配置 list 是弹窗
  getSaveAllChildInfo: '/wpsp/inner/children_edu_collect/list_all_child_info',
  // save 是更新数据
  getSaveAllChildSaveInfo: '/wpsp/inner/children_edu_collect/save_all_child_info',
  // 新增孩子
  addSaveChildInfo: '/wpsp/inner/children_edu_collect/save_child_info',
  // 删除孩子
  deleteSaveChildInfo: '/wpsp/inner/children_edu_collect/delete_child_info',
  // 孩子的下拉框选择
  updateChildrenCurrentClass: '/wpsp/inner/children_edu_collect/update_children_current_class',
  // 右侧外层数据修改
  updateOutSchoolCost: '/wpsp/inner/children_edu_collect/updateSchoolCost',
  // 右侧内层数据修改
  updateInnerSchoolCost: '/wpsp/inner/children_edu_collect/updateClassCost',
  // 收费弹窗全国查询
  getListAllProvinceName: '/wpsp/inner/children_edu_collect/list_all_province_name',
  // 收费弹窗表格查询
  getListProvinceCostInfo: '/wpsp/inner/children_edu_collect/list_province_cost_info',
  // 国外
  getListAllAbroadCostInfo: '/wpsp/inner/children_edu_collect/list_all_abroad_cost_info',
  // 下一步保存
  updateNextStep: '/wpsp/inner/wpsp_plan_version/next_step',
  // 收费标准中数据导入
  importData: '/wpsp/inner/children_edu_collect/updateSchoolAllCost',
  // 子女教育第二步
  // 测算分析现金流分析图
  getEduAnalyzeChart: '/wpsp/inner/child_edu_analyze/get_edu_analyze_chart',
  // 测算分析现金流分析图下面表格
  getEduAnalyzeTable: '/wpsp/inner/child_edu_analyze/get_edu_analyze_table',
  // 蒙特卡洛
  getEduAnalyzeFeasibility: '/wpsp/inner/child_edu_analyze/get_edu_analyze_feasibility',
  // 子女教育第四步
  // 理财详情
  lcDetails: '/wpsp/inner/financez/get',
  // 大额存单详情
  decdDetails: '/wmsp/out/deposit/product/get_deposit_data',
  // 客户概览
  overview: '/wpsp/inner/child_edu/get_measure_preview',
  // 测算分析
  Analysis: '/wpsp/inner/child_edu/get_measure_reserve',
  // 获取产品方案描述
  Programme: '/wpsp/inner/wpsp_product_plan/get_prd_des',
  // 保存产品方案描述
  saveProgramme: '/wpsp/inner/wpsp_product_plan/save_prd_des',
  // 每个子女信息
  children: '/wpsp/inner/children_edu_collect/list_all_child_info',
  // 完成规划，添加快照
  snapshot: '/wpsp/inner/wpsp_plan_version/save_plan_version',
  // 养老规划

  // 产品方案
  // 保存购买金额（单个）
  singleProductPurchase: '/wpsp/inner/wpsp_product_plan/single_upt_pension_purchase_amount',
  // 删除已选产品信息
  deleteSelectedProduct: '/wpsp/inner/wpsp_product_plan/del_pension_selected_product',
  // 新增产品方案描述信息
  schemeDescription: '/wpsp/inner/wpsp_product_plan/add_pension_plan_desc',
  // 产品方案===> 查询已选产品列表
  selectedPrdList: '/wpsp/inner/wpsp_product_plan/get_pension_selected_product_list',
  // 产品方案===> 查询常选产品列表
  regularElectionPrdList: '/wpsp/inner/wpsp_product_plan/get_pension_regular_product_list',
  // 产品方案===> 新增产品单选
  addRegularPrdSingle: '/wpsp/inner/wpsp_product_plan/single_add_pension_selected_product',
  // 查询产品方案描述信息
  querySchemeDescription: '/wpsp/inner/wpsp_product_plan/get_pension_plan_desc',
  // 批量新增已选产品信息
  addBatchSelectedProducts: '/wpsp/inner/wpsp_product_plan/batch_add_pension_selected_product',
  // 新增常选产品 (批量)
  addRegularPrdOld: '/wpsp/inner/wpsp_product_plan/batch_add_pension_regular_product',

  // 测算分析

  // 现金流分析
  cashFlowAnalysis: '/wpsp/inner/pension_analyze/get_pension_analyze_chart',
  // 可行性分析
  feasibilityAnalysis: '/wpsp/inner/pension_analyze/get_pension_analyze_feasibility',
  // 客户基本信息 测算概览
  customerInformation: '/wpsp/inner/pension_plan/get_pension_measure_preview',
  // 产品方案中的建议方案
  proposedScheme: '/wpsp/inner/pension_plan/get_pension_advice_scheme',
  // 资料收集

  // 查询养老储备金
  queryPensionReserve: '/wpsp/inner/pension_plan/get_pension_reserve',
  // 获取客户信息
  getCustomerInfo: '/wpsp/inner/pension_collect/get_customer_and_spouse_info',
  // 计发月数
  monthlyCount: '/wpsp/inner/pension_analyze/list_all_by_total_number_month',
  // 基本资料下一步数据保存
  saveData: '/wpsp/inner/pension_plan/save_first_next_step',
  // 财富报告
  create: '/wpsp/inner/plan_report/create', // 生成报告
  createDataList: '/wpsp/inner/plan_report/get_list', // 查询报告列表
  previewCreate: '/wpsp/inner/plan_report/preview', // 预览报告
  deletecreate: '/wpsp/inner/plan_report/delete', // 删除报告
  presentationAll: '/wpsp/inner/wpsp_presentation_plan/get_all_page', // 财富报告参数
  // 获取产品方案描述
  getListSelectedFinanceProduct: '/wpsp/outer/wpsp_product_plan/list_selected_finance_products', // 理财
  getListSelectedDepositProduct: '/wpsp/outer/wpsp_product_plan/list_selected_deposit_products', // 大额存单
  // 判断客户年龄是否大于100
  customerAge: '/wpsp/inner/pension_collect/get_customer_age',
  // 养老更新基本信息
  updateCustomer: '/wpsp/inner/pension_collect/update_customer_and_spouse_info',
  // 查询养老金来源的默认值
  queryDefault: '/wpsp/inner/pension_collect/get_pension_defaults',
  // 推荐产品组合
  productMix: '/wpsp/inner/asset_allocation/get_product_mix',
  // 饼图
  getCustomerBasicInfo: '/wpsp/inner/asset_allocation/get_customer_basic_info',
  // 新客户列表
  customerList: '/wpsp/cfezt/docking_common/get_cust_list',
  // 今日提醒
  get_remind_today: '/wpsp/inner/cust_homepage/get_remind_today',
  // 查询风险等级下拉框
  get_dict_list: '/wpsp/cfezt/docking_common/get_dict_list',
  // 获取E站通客户视图地址
  get_system_param_value: '/wpsp/cfezt/sys_param/get_system_param_value',
  // 获取客户信息
  getCustInfo: '/wpsp/cfezt/docking_common/get_cust_info',
  list_cust_supple: '/wpsp/inner/cust_info/list_cust_supple',
  // 资产分析-客户资产信息
  AssetsInformation: '/wpsp/inner/asset_analysis/finance_info',
  // 资产分析-查询指标分析
  indexAnalysis: '/wpsp/inner/asset_analysis/index_analysis',
  // 资产分析-资产结构占比
  AssetsRatio: '/wpsp/inner/asset_structure/get_cur_asset_structure',
  // 客户视图-财务信息
  getAssetLiability: '/wpsp/inner/customer_view/get_cust_finance_info',
  // 客户视图-修改财务信息
  modifyLiabilities: '/wpsp/inner/customer_view/update_financial_assets',
  // 完善财务信息收入支出查询
  get_Income: ' /wpsp/inner/cust_income_info/get_income',
  // 完善财务信息收入支出修改
  uptFinanceInfo: '/wpsp/inner/asset_analysis/upt_finance_info',
  // 饼图下面的数据
  getOptimizeAdvice: '/wpsp/inner/asset_allocation/get_optimize_advice',
  // 传给后台客户数据存入缓存
  save_redis_custinfo: '/wpsp/inner/cust_homepage/save_redis_custinfo',
  // 获取下拉框信息
  get_cust_basic_info: '/wpsp/inner/customer_view/get_cust_basic_info',
  // 修改下拉框数据
  update_cust_basic_info: '/wpsp/inner/customer_view/update_cust_basic_info',
  // 获取功能权限
  get_role_menu: '/wpsp/cfezt/function_list/get_role_menu',
  // 资产配置饼图数据
  get_detail: '/wpsp/inner/asset_allocation/fin_stru/get_detail',
  // 资产配置查看历史
  historyList: '/wpsp/inner/asset_allocation/history_config/list',
  historyDetail: '/wpsp/inner/asset_allocation/history_config/detail',
  // 保存报告
  saveReport: '/wpsp/inner/asset_allocation/history_config/create',
  // 产品推荐
  prd_unit_list: '/wpsp/inner/asset_allocation/prd_unit/list',
  finance_list: '/wmsp/finance/finance_info/list_for_asset', // 理财产品列表
  fund_list: '/wmsp/fund/fund_info/list_for_asset', // 基金产品列表
  preservationReplace: '/wpsp/inner/asset_allocation/prd_unit/save', // 确定替换
  recoveryDefault: '/wpsp/inner/asset_allocation/prd_unit/default', // 重置方案
  queryCustomer: '/wpsp/inner/asset_allocation/cust_config/detail', // 查询客户的风险等级和方案
  preservationScheme: '/wpsp/inner/asset_allocation/cust_config/update', // 保存客户方案
  cust_config_create: '/wpsp/inner/asset_allocation/cust_config/create', // 保存客户风险等级外屏调用
  insert_finance: '/wpsp/inner/cust_finance_info/insert_finance', // 新增资产信息
  get_by_identif: '/wpsp/inner/wpsp_deploy_tips/get_by_identifs', // 子女教育提示
};
